import * as THREE from 'three'
import BaseObject from './baseObject'

// Grid. Based on ThreeJS GridHelper code
export default class GlassGrid extends BaseObject {
  constructor(editor) {
    super(editor)

    this.scaleMap = [10, 7.5, 4, 2, 1.25, 0.75, 0.25]
    this.gridSettingsMap = [
      { minor: 1, major: 10 },    // Note: Lots of lines (10k+)... might need a way to optimize this (only show surrounding area of camera & snap it to next pixel?)
      { minor: 5, major: 50 },
      { minor: 10, major: 100 },
      { minor: 25, major: 250 },
      { minor: 50, major: 500 },
      { minor: 100, major: 1000 },
      { minor: 200, major: 2000 }
    ]

    this.sceneObject = new THREE.Object3D()
    this.editor.scene.add(this.sceneObject)
  }

  /**
   * Dispose the object
   */
   dispose() {
    super.dispose()

    // TODO: Release previously allocated geometry objects
  }

  // Get the grid minor division size for a zoom scale
  getGridMinorDivisionSize(zoomScale) {
    var scaleIndex = 0
    this.scaleMap.forEach((scale, index) => {
      if(zoomScale <= scale)
        scaleIndex = index
    })

    return this.gridSettingsMap[scaleIndex].minor
  }

  onBeforeRender() {
    if(!this.editor.camera)
      return
      
    // Adjust grid as the zoom level changes
    var scaleIndex = 0
    this.scaleMap.forEach((scale, index) => {
      if(this.editor.camera.zoom <= scale)
        scaleIndex = index
    })

    this.gridList.forEach((gridObj, index) => {
      gridObj.visible = index == scaleIndex
    })
  }

  updateSceneObject() {
    this.clearSceneObject()    

    // TODO: Release previously allocated geometry objects

    // Pre-build the grids for different zoom levels
    this.gridList = []
    this.gridSettingsMap.forEach(settings => {
      let obj = this.buildGridObject(settings.minor, settings.major)
      this.gridList.push(obj)
    })
  }

  buildGridObject(minorDivisionSize, majorDivisionSize) {
    let size = this.editor.settings.maxWorldWidth
    let halfSize = size / 2

    let axisCol = new THREE.Color(this.editor.getTheme().gridAxisColour)
    let majorCol = new THREE.Color(this.editor.getTheme().gridMajorColour)
    let minorCol = new THREE.Color(this.editor.getTheme().gridMinorColour)
    
    var vertices = [], colors = [];
    var colourIndex = 0
    var i, j

    // Minor lines
    let minDivCount = (size / minorDivisionSize)
    for(i=0, j=-halfSize; i<minDivCount; i++, j += minorDivisionSize) {
      vertices.push(-halfSize, j, 0, halfSize, j, 0)
      vertices.push(j, -halfSize, 0, j, halfSize, 0)

      minorCol.toArray(colors, colourIndex); colourIndex += 3;
      minorCol.toArray(colors, colourIndex); colourIndex += 3;
      minorCol.toArray(colors, colourIndex); colourIndex += 3;
      minorCol.toArray(colors, colourIndex); colourIndex += 3;
    }

    let majorDivCount = (size / majorDivisionSize)
    for(i=0, j=-halfSize; i<=majorDivCount; i++, j += majorDivisionSize) {
      vertices.push(-halfSize, j, 0, halfSize, j, 0)
      vertices.push(j, -halfSize, 0, j, halfSize, 0)

      majorCol.toArray(colors, colourIndex); colourIndex += 3;
      majorCol.toArray(colors, colourIndex); colourIndex += 3;
      majorCol.toArray(colors, colourIndex); colourIndex += 3;
      majorCol.toArray(colors, colourIndex); colourIndex += 3;
    }

    // Axis Lines
    vertices.push(-halfSize, 0, 0, halfSize, 0, 0)
    vertices.push(0, -halfSize, 0, 0, halfSize, 0)
    axisCol.toArray(colors, colourIndex); colourIndex += 3;
    axisCol.toArray(colors, colourIndex); colourIndex += 3;
    axisCol.toArray(colors, colourIndex); colourIndex += 3;
    axisCol.toArray(colors, colourIndex); colourIndex += 3;

    var geometry = new THREE.BufferGeometry()
    geometry.setAttribute( 'position', new THREE.Float32BufferAttribute( vertices, 3 ) );
    geometry.setAttribute( 'color', new THREE.Float32BufferAttribute( colors, 3 ) );

    var material = new THREE.LineBasicMaterial({
      vertexColors: THREE.VertexColors,
      transparent: true,
      opacity: this.editor.getTheme().gridLineOpacity
    })

    let object = new THREE.LineSegments(geometry, material)
    object.position.z = 10
    object.visible = false

    this.sceneObject.add(object)

    return object
  }
}